// extracted by mini-css-extract-plugin
module.exports = {"prefix":"ReportRoleName_prefix_TXowi"};